import React, { useEffect, useRef, useState } from "react";
import useIsMobile from "../hooks/useIsMobile";

const IconButton = ({
  iconSize = "size-7",
  icon,
  hoverIcon = "",
  text = "",
  textSize = "text-[10px] md:text-[12px]",
  onClick = null,
  disabled,
}) => {
  const [isHovering, setIsHovering] = useState(false);
  const iconRef = useRef();
  const isMobile = useIsMobile();

  const handleClick = (event) => {
    if (disabled || !onClick) {
      return;
    }
    onClick(event);
  };

  useEffect(() => {
    if (isMobile) {
      return;
    }

    const iconElement = iconRef.current;
    const handleMouseEnter = () => setIsHovering(true);
    const handleMouseLeave = () => setIsHovering(false);

    if (iconElement) {
      iconElement.addEventListener("mouseenter", handleMouseEnter);
      iconElement.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      if (iconElement) {
        iconElement.removeEventListener("mouseenter", handleMouseEnter);
        iconElement.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, [iconRef]);

  return (
    <div
      ref={iconRef}
      onClick={handleClick}
      className={`${iconSize} flex flex-col  justify-center items-center cursor-pointer ${text ? "gap-1" : ""} 
      ${isHovering && !hoverIcon ? " bg-red-200 rounded-full" : ""}
      ${disabled ? "pointer-events-none" : ""}
      `}
    >
      <img className={iconSize} src={isHovering && hoverIcon && !disabled ? hoverIcon : icon} alt={text} />
      {text && <span className={`${textSize} text-black font-medium italic`}>{text}</span>}
    </div>
  );
};

export default IconButton;
